var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('v-progress-circular',{staticClass:"progress-spinner",attrs:{"size":40,"indeterminate":"","color":"primary"}}):_c('v-file-input',_vm._b({attrs:{"outlined":"","dense":"","prepend-icon":"mdi-plus"},on:{"change":_vm.addFile}},'v-file-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }